import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'rma-no-profiles-found',
  standalone: true,
  templateUrl: './no-profiles-found.component.html',
  imports: [MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col gap-2 p-8 rounded-md bg-steel-10 text-center',
  },
})
export class NoProfilesFoundComponent {
  public readonly title = input.required<string>();
  public readonly body = input.required<string>();
  public readonly cta = input<string>();

  public readonly navigate = output();
}
